import Vue from 'vue';
import VueRouter from 'vue-router';

import { checkJWT } from '@/assets/js/auth';
import { checkJWTValue, toLogin, updateJWT } from '@/assets/js/jwt';
import api from '@/api';
import store from '@/store';

import Cookies from 'js-cookie';

import jobsRouter from './jobs';
import company from './company';
import accountRouter from './account'
import cvRouter from './cv'
import operatingRouterList from "./operating";
import planningRouters from "./planning";
import aiRouter from './ai';
import { getUserInfo, get_tUser, getCookieValue } from '@/assets/js/util';
import { getRouteData, getPageType } from '@/assets/js/routeMap';

Vue.use(VueRouter);

// 全局的方法
const gioSetPeople = async () => {
  console.log('gioSetPeople')
  let _t = Cookies.get('_t');
  if (_t) {
    let tokenPayload = JSON.parse(window.atob(_t.split('.')[1]))
    let res = await api.gio.gio_data(tokenPayload.User.c_t)
    if (res.code === 1000) {
      gio('setUserId', res.data.user_id)
      gio('people.set', res.data)
      gio('cv_account_token', tokenPayload)
    }
  } else {
    console.log('未登录')
  }
}

const setBaiDuPush =  () => {
  if (process.env.VUE_APP_EVN === 'prod') {
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?2e28467a211ca17f7aadc13ddd78a879";
      hm.defer = true
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }
}

const routes = [
  ...jobsRouter,
  ...company,
  ...accountRouter,
  ...cvRouter,
  ...operatingRouterList,
  ...planningRouters,
  ...aiRouter
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  store.commit('app/IS_DOUBLE', false);
  //没有c端账户&&有b账户&&不是去往选择身份页面 ，根据jwt创建c账户
  if(!get_tUser().c_t && !!get_tUser().h_t && to.name !=='TemplateMatchesNew'){
    createCvAccount({to, from, next});
    return
  }
  await next();
})

router.afterEach(async (to, from) => {
  let routeData = getRouteData(to);
  let page_type = getPageType(to.name) || '';
  let referrer = {
    url: from.path !== '/' ? from.path : window.referrer,
    title: '',
  }
  let url = {
    url: window.origin + to.path,
    title: '', 
  }
  window.reportUserBrowseHistory(referrer, url, 'pc_vue', page_type, routeData)
  
  setBaiDuPush()
  setTimeout(() => {
    gioSetPeople().then(
      r => {
        // console.log(r)
      }
    )
  }, 1500);
})

// 根据jwt创建c账户
const createCvAccount = async ({to, from, next})=>{
  let data = {
    source: 'pc_browser',
  }
  api.auth.create_cv_account(data).then(async res=>{
    //创建成功
    if(res.code === 1000){
      let { jwt, jwt_timestamp } = res.data;
      await updateJWT({
        jwt,
        jwt_timestamp
      })
      toLogin({login:false});
      window.location.href = '/template_matches/new'
      // next('/template_matches/new');
    }else{
      let { hostname } = window.location
      //创建失败，重新登录
      Cookies.remove('_t', {
        domain: `${hostname.split('.')[1]}.${hostname.split('.')[2]}`,
        path: '/',
      });
      toLogin({login:true});
    }
  })

}

export default router;
